var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#27B2E7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 0l33.54 33.54V14.598L67.942 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.46 9.46L92 43V24.058L77.402 9.46z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FEFEFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.516 4.893c.269 1.74.097 3.916-.187 5.749l.023.008c.32-.36 2.88-2.978 2.88-2.978l.918.94-4.76 4.87-.74-.756c.486-2.1.702-4.352.59-6.161l-.022-.008c-.373.413-3.283 3.39-3.283 3.39l-.918-.939 4.76-4.871.74.756zM76.94 13.513l-.783.801-1.724-1.763-1.194 1.221 1.433 1.466-.791.81-1.433-1.466-1.208 1.237 1.962 2.007-.784.802-2.895-2.962 4.76-4.871zM79.149 15.773c-.859 1.29-2.097 3.58-2.388 4.535l.015.015c.73-.32 3.529-1.855 4.44-2.435l.775.794c-.567.931-2.037 3.81-2.343 4.565l.015.016c.933-.298 3.209-1.604 4.395-2.467l.836.856c-1.395 1.107-4.865 2.947-6.402 3.298l-.537-.55c.239-.87 1.26-3.168 2.03-4.459l-.016-.015c-1.26.786-3.514 1.81-4.357 2.077l-.552-.565c.35-1.565 2.134-5.13 3.223-6.55l.866.885z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBanner);
export default __webpack_public_path__ + "static/media/new-banner.9a811a669a41533d5a012599a02735f1.svg";
export { ForwardRef as ReactComponent };